module.exports = __webpack_public_path__ + "static/18-af0af18706a31aeb42facfef2b5ad394.jpg";